<template>
  <s-section
    class="content-widget"
    :title="content.title"
  >
    <template v-if="hasManyBlocks">
      <a-tabs
        :default-active-key="0"
        :tab-position="$nuxt.$breakpoints.sLg ? 'top' : 'left'"
        class="content-widget__tabs"
      >
        <a-tab-pane
          v-for="(block, i) in content.blocks"
          :key="i"
          :tab="block.title"
        >
          <content-widget-block :block="block">
            <slot></slot>
          </content-widget-block>
        </a-tab-pane>
      </a-tabs>
    </template>

    <template v-else>
      <div class="row">
        <div class="col-xl-9 ml-auto">
          <div
            v-if="content.blocks"
            class="content-widget__blocks"
          >
            <content-widget-block
              v-for="block in content.blocks"
              :key="block.id"
              :block="block"
            ></content-widget-block>
          </div>
        </div>
      </div>
    </template>
  </s-section>
</template>

<script>
import ContentWidgetBlock from './ContentWidgetBlock'

export default {
  name: 'ContentWidget',
  components: {
    ContentWidgetBlock
  },
  props: {
    content: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    hasManyBlocks() {
      return this.content.blocks.length > 1
    }
  }
}
</script>

<style lang="scss">
.content-widget__tabs {
  .ant-tabs-left-bar {
    max-width: calc(#{$grid-column} * 3 - 20px);
  }

  .ant-tabs-nav .ant-tabs-tab {
    white-space: normal;

    @media (max-width: $breakpoint-lg) {
      max-width: calc(100vw - 84px);
      text-align: center;
    }
  }
}
</style>